import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LinearProgress from 'material-ui/LinearProgress';

import ReceiptsTable from './ReceiptsTable';
import FlatButton from 'material-ui/FlatButton';
import DatePicker from 'material-ui/DatePicker';
import Dialog from 'material-ui/Dialog';
import { Col, Row } from 'react-flexbox-grid';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import ContentSelectAll from 'material-ui/svg-icons/content/select-all';

import RaisedButton from 'material-ui/RaisedButton';

import * as receiptActions from '../actions';
import MenuItem from 'material-ui/MenuItem';
// import Immutable from 'immutable';
import Paper from 'material-ui/Paper';

import { Toolbar, ToolbarGroup, ToolbarSeparator } from 'material-ui/Toolbar';

import api from '../../../utils/api';

import moment from 'moment';

import { push } from 'connected-react-router';

import { branchesSelector, usersSelector } from '../selectors';

import styles from './ReceiptsList.scss';

import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';

require('./ReceiptsList.scss');

class Receipts extends React.Component {
    static propTypes = {
        auth: PropTypes.object,
        actions: PropTypes.object,
        router: PropTypes.object,
        receipts: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            showDeletionDialog: false,
            showAllDeletionDialog: false,
            showFormatSelectionDialog: false,
            open: false,
        };
    }

    handlePrintSelectionPopover = event => {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    handlePrintSelectionRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    componentDidMount = () => {
        // TODO: Add default form to range. with Now - 1 week
        this.props.fetchReceipts({
            from: moment()
                .subtract(3, 'days')
                .startOf('day'),
            to: moment().endOf('day'),
        });
    };

    componentWillReceiveProps = () => {};

    getReceipts = (type = 'all') => {
        const receipts = this.props.receipts
            .get('items')
            .filter(receipt => {
                if (type === 'all') {
                    return true;
                } else {
                    return receipt.get('type') === type;
                }
            })
            .filter(receipt => {
                if (this.props.selectDuplicates == true) {
                    return receipt.get('duplicate') == true;
                } else {
                    return receipt;
                }
            })
            .filter(receipt => {
                if (this.props.selectPrinted == true) {
                    return receipt.get('printed_at') === null;
                } else {
                    return receipt;
                }
            })
            .filter(receipt => {
                if (
                    this.dateFromString(receipt.get('date')) > this.props.receipts.get('from') &&
                    this.dateFromString(receipt.get('date')) < this.props.receipts.get('to')
                ) {
                    return true;
                } else {
                    return false;
                }
            })
            .filter(receipt => {
                if (this.props.selectedUser === '-1') {
                    return true;
                } else {
                    return this.props.selectedUser === receipt.get('user');
                }
            })
            .filter(receipt => {
                if (this.props.selectedBranch === '-1') {
                    return true;
                } else {
                    return this.props.selectedBranch === receipt.get('branch');
                }
            })
            .sortBy(receipt => moment(receipt.get('date')))
            .reverse();

        return receipts;
    };

    showFormatSelectionDialog = () => {
        this.setState(
            Object.assign({}, this.state, {
                showFormatSelectionDialog: true,
            })
        );
    };

    hideFormatSelectionDialog = () => {
        this.setState(
            Object.assign({}, this.state, {
                showFormatSelectionDialog: false,
            })
        );
    };

    showAllDeletionDialog = () => {
        this.setState(
            Object.assign({}, this.state, {
                showAllDeletionDialog: true,
            })
        );
    };

    _handleFromChange = (value, date) => {
        this.props.actions.changeReceiptFromDate(moment(date).startOf('day'));
        const from = this.props.receipts.get('from');
        const to = this.props.receipts.get('to');
        this.props.fetchReceipts({ from, to });
    };

    _handleToChange = (value, date) => {
        this.props.actions.changeReceiptToDate(moment(date).endOf('day'));
    };

    _handleReceiptTypeChange = (name, event) => {
        this.props.actions.changeReceiptFilterType(this.props.receipts.get('types').get(event));
    };

    _handleReceiptUserFilter = (name, event) => {
        this.props.actions.changeReceiptUserFilter(this.props.users.get(event).payload);
    };

    _handleReceiptBranchFilter = (name, event) => {
        this.props.actions.changeReceiptBranchFilter(this.props.branches.get(event).payload);
    };

    handleSearchBranch = (event, value) => {
        this.props.actions.changeReceiptBranchFilter(value);
    };

    _handleDownload = event => {
        event.preventDefault();
    };

    nameForType = receipt_type => {
        switch (receipt_type) {
            case 'all':
                return 'Alle';
            case 'order':
                return 'Bestellung';
            case 'stocktaking':
                return 'Inventur';
            case 'rearrangement':
                return 'Umlagerung';
            case 'stock_flow_adjustment':
                return 'Bestandsanpassung';
            case 'goods_receipt':
                return 'Wareneingang';
            case 'price_change':
                return 'Preisänderung';
            case 'customer_order':
                return 'Kundenbestellung';
            case 'retour':
                return 'Lieferantenretoure';
        }
    };

    longDateFormat = date => {
        return moment(date).format('DD.MM.YY');
    };

    dateFromString = string => {
        return moment(string);
    };

    formatDate = date => {
        return moment(date).format('DD.MM.YYYY');
    };

    _onRowSelection = row => {
        const select_branch =
            this.props.data_format === 'neo' || this.props.data_format === 'futura';
        if (this.props.selectedReceipts.includes(row)) {
            this.props.actions.selectedReceipts(
                this.props.selectedReceipts.filter(value => value !== row).toJS(),
                { selectBranch: select_branch }
            );
        } else {
            this.props.actions.selectedReceipts(this.props.selectedReceipts.push(row).toJS(), {
                selectBranch: select_branch,
            });
        }
    };

    _onRowClick = rowData => {
        this.props.push('/receipts/' + rowData.id);
    };

    urlForCSVDownload = () => {
        let receipts = this.props.receipts.get('selectedReceipts');
        let string = receipts.reduce(
            (reduction, value) => reduction + 'receipt_ids[]=' + value + '&',
            ''
        );
        const token = localStorage.getItem('scantouch_token');
        const jsonToken = JSON.parse(token);
        return '/api/v1/' + jsonToken.tenant_name + '/receipts/csv/download' + '?' + string;
    };

    urlForALLCSVDownload = () => {
        const token = localStorage.getItem('scantouch_token');
        const jsonToken = JSON.parse(token);
        const selectedUser = this.props.selectedBranch;
        const selectedBranch = this.props.selectedUser;
        const from = this.props.receipts.get('from');
        const to = this.props.receipts.get('to');
        return (
            '/api/v1/' +
            jsonToken.tenant_name +
            '/receipts/csv/download_all?selectedUser=' +
            selectedUser +
            '&selectedBranch=' +
            selectedBranch +
            '&from=' +
            from +
            '&to=' +
            to
        );
    };

    downloadDisabled = () => {
        const receipts = this.props.receipts.get('selectedReceipts');
        return receipts.size === 0;
    };

    selectionEnabled = () => {
        return this.props.receipts.get('filterByType') !== 'all';
    };

    readableDataFormat = data_format => {
        switch (this.props.receipts.get('filterByType')) {
            case 'stocktaking':
                switch (data_format) {
                    case 'h4_f3':
                        return 'H4000 - F3000 Export';
                    case 'f2':
                        return 'F2000 Export';
                    case 'intersys5':
                        return 'INTERSYS5';
                    case 'prohandel':
                        return 'Prohandel';
                    case 'wsscsv':
                        return 'WWS CSV';
                    case 'neo':
                        return 'NEO';
                    case 'futura_ers':
                        return 'FuturaERS';
                    case 'topm_cosys':
                        return 'TopM-Cosys';
                    case 'advarics':
                        return 'Advarics';
                }
            default:
                return 'Export';
        }
        return 'Export';
    };

    deleteReceipts = () => {
        this.setState({
            showDeletionDialog: true,
        });
    };

    exportSelection = () => {
        let receipts = this.props.receipts.get('selectedReceipts').toJS();
        const selectedBranch = this.props.selectedBranch;
        const selectedUser = this.props.selectedUser;
        const from = this.props.receipts.get('from');
        const to = this.props.receipts.get('to');

        this.props.exportReceipts({
            receipts: receipts,
            selectedUser,
            selectedBranch,
            from,
            to,
        });
    };

    exportSelectionToAdvarics = () => {
        let receipts = this.props.receipts.get('selectedReceipts').toJS();
        const selectedBranch = this.props.selectedBranch;
        const selectedUser = this.props.selectedUser;
        const from = this.props.receipts.get('from');
        const to = this.props.receipts.get('to');

        this.props.exportReceiptsToAdverics({
            receipts: receipts,
            selectedUser,
            selectedBranch,
            from,
            to,
        });
    };

    printSelection = (include_positions = false) => {
        let receipts = this.props.receipts.get('selectedReceipts').toJS();
        const selectedBranch = this.props.selectedBranch;
        const selectedUser = this.props.selectedUser;
        const from = this.props.receipts.get('from');
        const to = this.props.receipts.get('to');

        this.props.printSelectedReceipts({
            receipts: receipts,
            selectedUser,
            selectedBranch,
            from,
            to,
            include_positions,
        });
        this.handlePrintSelectionRequestClose();
    };

    printSelectionWithItems = () => {
        this.printSelection(true);
    };

    printSelectionWithoutItems = () => {
        this.printSelection(false);
    };

    submitDelete = () => {
        let receipts = this.props.receipts.get('selectedReceipts').toJS();
        const selectedBranch = this.props.selectedBranch;
        const selectedUser = this.props.selectedUser;
        const from = this.props.receipts.get('from');
        const to = this.props.receipts.get('to');

        this.props.deleteReceipts({
            receipts: receipts,
            selectedUser,
            selectedBranch,
            from,
            to,
        });

        this.setState({
            showDeletionDialog: false,
        });
    };

    handleClose = () => {
        this.setState({
            showDeletionDialog: false,
            showAllDeletionDialog: false,
        });
    };

    submitDeleteAll = receipts => () => {
        let receiptsToDelete = receipts.map(receipt => receipt.get('id')).toJS();
        this.props.deleteAllReceipts({
            receipts: receiptsToDelete,
        });
        this.handleClose();
    };

    showSettings = () => {
        this.props.push('/settings');
    };

    handleOnRequestChange = (event, val) => {
        if (val === '1') {
            const receipts = this.getReceipts(this.props.receipts.get('filterByType'));
            this.props.actions.selectedReceipts(receipts.map(receipt => receipt.get('id')).toJS());
        }
        if (val === '2') {
            const receipts = this.getReceipts(this.props.receipts.get('filterByType'));
            this.props.actions.selectedReceipts(
                receipts
                    .filter(receipt => receipt.get('exported_at') === null)
                    .map(receipt => receipt.get('id'))
                    .toJS()
            );
        }
        if (val === '3') {
            const receipts = this.getReceipts(this.props.receipts.get('filterByType'));
            this.props.actions.selectedReceipts(
                receipts
                    .filter(receipt => receipt.get('duplicate') === true)
                    .map(receipt => receipt.get('id'))
                    .toJS(),
                { selectDuplicates: true }
            );
        }
        if (val === '4') {
            const receipts = this.getReceipts(this.props.receipts.get('filterByType'));
            this.props.actions.selectedReceipts(
                receipts
                    .filter(receipt => receipt.get('printed_at') === null)
                    .map(receipt => receipt.get('id'))
                    .toJS(),
                { selectPrinted: true }
            );
        }
        if (val === '5') {
            this.props.actions.selectedReceipts([], { selectDuplicates: false });
        }
    };

    render = () => {
        let receipts = this.getReceipts(this.props.receipts.get('filterByType'));
        let selectedBranch = null;

        const actions = [
            <FlatButton label="Abbrechen" primary onClick={this.handleClose} />,
            <FlatButton
                label="Belege löschen"
                primary
                keyboardFocused
                onClick={this.submitDelete}
            />,
        ];

        const deleteAllReceiptsActions = [
            <FlatButton label="Abbrechen" primary onClick={this.handleClose} />,
            <FlatButton
                label="Alle Belege löschen"
                primary
                keyboardFocused
                onClick={this.submitDeleteAll(receipts)}
            />,
        ];

        const formatSelectionDialogActions = [
            <FlatButton label="Ok" primary onClick={this.hideFormatSelectionDialog} />,
            <FlatButton
                label="Zu den Einstellungen"
                primary
                keyboardFocused
                onClick={this.showSettings}
            />,
        ];

        const menuItems = this.props.receipts
            .get('types')
            .map(receiptType => ({
                payload: receiptType,
                text: this.nameForType(receiptType),
            }))
            .map(item => (
                <MenuItem key={item.payload} value={item.payload} primaryText={item.text} />
            ));

        const users = this.props.users.map(item => (
            <MenuItem key={item.payload} value={item.payload} primaryText={item.text} />
        ));
        const branches = this.props.branches.map(item => (
            <MenuItem key={item.payload} value={item.payload} primaryText={item.text} />
        ));

        return (
            <div className="receipts">
                {this.props.isFetching && (
                    <Row>
                        <Col md={12} sm={12} xs={12}>
                            <LinearProgress
                                mode="indeterminate"
                                color="#3babd0"
                                style={{
                                    left: '0px',
                                    height: '10px',
                                    top: '63px',
                                    right: '0px',
                                    position: 'absolute',
                                }}
                            />
                        </Col>
                    </Row>
                )}
                <h2>Belege</h2>
                <Row>
                    <Col xs>
                        <DatePicker
                            hintText="de version"
                            floatingLabelText="Von"
                            DateTimeFormat={Intl.DateTimeFormat}
                            cancelLabel="Abbrechen"
                            okLabel="Ok"
                            autoOk
                            value={this.props.receipts.get('from').toDate()}
                            locale="de"
                            formatDate={this.formatDate}
                            onChange={this._handleFromChange}
                        />
                    </Col>
                    <Col xs>
                        <DatePicker
                            floatingLabelText="Bis"
                            hintText="de version"
                            DateTimeFormat={Intl.DateTimeFormat}
                            cancelLabel="Abbrechen"
                            okLabel="Ok"
                            autoOk
                            value={this.props.receipts.get('to').toDate()}
                            locale="de"
                            formatDate={this.formatDate}
                            onChange={this._handleToChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={3}>
                        <SelectField
                            hintText="Hint Text"
                            value={this.props.receipts.get('filterByType')}
                            floatingLabelText="Beleg Typ"
                            menuItems={menuItems}
                            onChange={this._handleReceiptTypeChange.bind(this)}>
                            {menuItems}
                        </SelectField>
                    </Col>
                    <Col xs={3}>
                        <SelectField
                            hintText="Hint Text"
                            value={this.props.receipts.get('selectedUser')}
                            floatingLabelText="Erfasser"
                            onChange={this._handleReceiptUserFilter.bind(this)}>
                            {users}
                        </SelectField>
                    </Col>
                    <Col xs={3}>
                        <SelectField
                            hintText="Hint Text"
                            value={this.props.receipts.get('selectedBranch')}
                            floatingLabelText="Filiale"
                            onChange={this._handleReceiptBranchFilter.bind(this)}>
                            {branches}
                        </SelectField>
                    </Col>
                    <Col xs={3}>
                        <TextField
                            value={
                                this.props.selectedBranch != '-1' ? this.props.selectedBranch : ''
                            }
                            floatingLabelText="Filiale suchen"
                            onChange={this.handleSearchBranch.bind(this)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs>
                        <Toolbar>
                            <ToolbarGroup firstChild>
                                <IconMenu
                                    iconButtonElement={
                                        <IconButton className={styles.icon}>
                                            <ContentSelectAll />
                                        </IconButton>
                                    }
                                    open={this.state.openMenu}
                                    onChange={this.handleOnRequestChange}>
                                    <MenuItem value="1" primaryText="Alle auswählen" />
                                    <MenuItem value="2" primaryText="Nicht exportierte auswählen" />
                                    <MenuItem value="3" primaryText="Doppelte Regale auswählen" />
                                    <MenuItem
                                        value="4"
                                        primaryText="Noch nicht gedruckte auswählen"
                                    />
                                    <MenuItem value="5" primaryText="Auswahl aufheben" />
                                </IconMenu>
                            </ToolbarGroup>
                            <ToolbarGroup>
                                <ToolbarSeparator />
                                {this.props.data_format === 'advarics' && (
                                    <RaisedButton
                                        label="Auswahl übertragen"
                                        primary
                                        linkButton
                                        onClick={this.exportSelectionToAdvarics}
                                        disabled={this.downloadDisabled() || !this.selectionEnabled()}
                                    />
                                )}
                                <RaisedButton
                                    label="Auswahl exportieren"
                                    primary
                                    linkButton
                                    onClick={this.exportSelection}
                                    disabled={this.downloadDisabled() || !this.selectionEnabled()}
                                />
                                {this.props.receipts.get('filterByType') === 'stocktaking' && (
                                    <RaisedButton
                                        label="Auswahl drucken"
                                        primary
                                        onClick={this.handlePrintSelectionPopover}
                                        disabled={
                                            this.downloadDisabled() || !this.selectionEnabled()
                                        }>
                                        <Popover
                                            open={this.state.open}
                                            anchorEl={this.state.anchorEl}
                                            anchorOrigin={{
                                                horizontal: 'left',
                                                vertical: 'bottom',
                                            }}
                                            targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                                            onRequestClose={this.handlePrintSelectionRequestClose}>
                                            <Menu>
                                                <MenuItem
                                                    primaryText="Mit Positionen"
                                                    onClick={this.printSelectionWithItems}
                                                />
                                                <MenuItem
                                                    primaryText="Ohne Positionen"
                                                    onClick={this.printSelectionWithoutItems}
                                                />
                                            </Menu>
                                        </Popover>
                                    </RaisedButton>
                                )}
                                <RaisedButton
                                    label="Auswahl löschen"
                                    primary
                                    onClick={this.deleteReceipts}
                                    disabled={this.downloadDisabled() || !this.selectionEnabled()}
                                />
                            </ToolbarGroup>
                        </Toolbar>
                    </Col>
                </Row>
                <div className="filter-bar">
                    <div className="type-selection">
                        <div className="inline-block" />
                        <div className="inline-block" />
                        <div className="inline-block" />
                    </div>
                </div>
                <div className="clear" />
                <Paper zDepth={1}>
                    <div className="paper-inner">
                        <ReceiptsTable
                            selectedBranch={selectedBranch}
                            isFetching={this.props.receipts.get('isFetching')}
                            receipts={receipts}
                            selectedReceipts={this.props.receipts.get('selectedReceipts')}
                            selectionEnabled={this.selectionEnabled()}
                            onRowSelection={this._onRowSelection}
                            onRowClick={this._onRowClick}
                        />
                    </div>
                </Paper>
                <Dialog
                    title="Belege löschen"
                    modal={false}
                    actions={actions}
                    open={this.state.showDeletionDialog}
                    onRequestClose={this.handleClose}>
                    Sind Sie sicher, dass Sie die Belege löschen wollen?
                </Dialog>
                <Dialog
                    title="Kein Satzaufbau ausgewählt"
                    modal={false}
                    actions={formatSelectionDialogActions}
                    open={this.state.showFormatSelectionDialog}
                    onRequestClose={this.hideFormatSelectionDialog}>
                    Bitte wählen Sie zuerst einen Satzaufbau in den Einstellungen
                </Dialog>
                <Dialog
                    title="Alle Belege löschen"
                    modal={false}
                    actions={deleteAllReceiptsActions}
                    open={this.state.showAllDeletionDialog}
                    onRequestClose={this.handleClose}>
                    Sind Sie sicher, dass Sie alle Belege löschen wollen?
                </Dialog>
            </div>
        );
    };
}

function mapStateToProps(state) {
    return {
        data_format: state.user.get('data_format'),
        receipts: state.receipts,
        routing: state.routing,
        auth: state.auth,
        users: usersSelector(state),
        branches: branchesSelector(state),
        isFetching: state.receipts.get('isFetching'),
        selectedReceipts: state.receipts.get('selectedReceipts'),
        selectedUser: state.receipts.get('selectedUser'),
        selectedBranch: state.receipts.get('selectedBranch'),
        selectDuplicates: state.receipts.get('selectDuplicates'),
        selectPrinted: state.receipts.get('selectPrinted'),
    };
}

const mapDispatchToProps = dispatch => ({
    push: payload => dispatch(push(payload)),
    actions: bindActionCreators(receiptActions, dispatch),
    fetchReceipts: payload => dispatch(api.actions.receipts.fetchReceipts(payload)),
    deleteAllReceipts: payload => dispatch(api.actions.receipts.deleteReceipts(payload)),
    deleteReceipts: payload => dispatch(api.actions.receipts.deleteReceipts(payload)),
    exportReceipts: payload => dispatch(api.actions.receipts.exportReceipts(payload)),
    exportReceiptsToAdverics: payload => dispatch(api.actions.receipts.exportReceiptsToAdverics(payload)),
    printReceipts: payload => dispatch(api.actions.receipts.printReceipts(payload)),
    printSelectedReceipts: payload => dispatch(api.actions.receipts.printSelectedReceipts(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Receipts);
